var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('notifications'),_c('side-bar',[_c('template',{slot:"links"},[_c('sidebar-item',{attrs:{"link":{
          name: 'Dashboard',
          path: '/dashboard',
          icon: 'ni ni-tv-2 text-primary',
        }}}),_c('sidebar-item',{attrs:{"link":{
          name: 'Inquiries',
          path: '/inquiries',
          icon: 'ni ni-chat-round text-primary',
        }}}),_c('sidebar-item',{attrs:{"link":{
          name: 'Accounts',
          path: '/accounts',
          icon: 'ni ni-circle-08 text-primary',
        }}}),_c('sidebar-item',{attrs:{"link":{
          name: 'Churches',
          path: '/churches',
          icon: 'ni ni-building text-primary',
        }}}),_c('sidebar-item',{attrs:{"link":{
          name: 'Members',
          path: '/members',
          icon: 'ni ni-single-02 text-primary',
        }}})],1)],2),_c('div',{staticClass:"main-content"},[_c('dashboard-navbar',{attrs:{"type":_vm.$route.meta.navbarType}}),_c('div',{on:{"click":function($event){return _vm.$sidebar.displaySidebar(false)}}},[_c('fade-transition',{attrs:{"duration":200,"origin":"center top","mode":"out-in"}},[_c('router-view')],1)],1),(!_vm.$route.meta.hideFooter)?_c('content-footer'):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }